module.exports = __webpack_public_path__ + "img/dinheiro-modal.25822713.svg";